import { formFieldErrorHtml, mergePreviewStyle, toRGBA, getFontFamily } from "../parser/utils";
import { getFormLableStyleStr } from "../FormText/FormBaseStyle";
export default ({ data, id, root }) => {
  const {
    label,
    options,
    required,
    // Explicit padding values
    hideLabel,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    optionsDefaultFont,
    optionsFontSize,
    optionsFontColor,
    optionsHorizonAlignment,
    labelDefaultFont,
    labelFontSize,
    labelFontColor,
    labelHorizonAlignment,
  } = data;

  const {
    formBorderWidth,
    formBorderStyle,
    formBorderColor,
    formBorderRadius,
    formTextColor,
  } = root.data;

  // 1. Get base styles string
  const baseLabelStyleStr = getFormLableStyleStr(data, root.data) || "";

  const overrideStyleParts = [];
  overrideStyleParts.push("display: flex");
  overrideStyleParts.push("align-items: flex-start");

  const finalLabelFontColor = labelFontColor || formTextColor;
  if (finalLabelFontColor) {
    overrideStyleParts.push(`color: ${toRGBA(finalLabelFontColor)}`);
  }
  if (labelDefaultFont) {
    overrideStyleParts.push(`font-family: ${labelDefaultFont}`);
  }
  const trimmedLabelFontSize = String(labelFontSize || "").trim();
  if (trimmedLabelFontSize && trimmedLabelFontSize !== "0") {
    overrideStyleParts.push(`font-size: ${trimmedLabelFontSize}px`);
  }
  overrideStyleParts.push(
    `justify-content: ${labelHorizonAlignment || "start"}`
  );

  // This string is what you consider your 'labelInlineStyle'
  const labelInlineStyleString = overrideStyleParts.join("; ");

  // 3. Use the merge function with the desired parameter name
  const finalLabelStyleStr = mergePreviewStyle(
    baseLabelStyleStr,
    labelInlineStyleString
  );

  // 强制所有选项行可换行、自动撑高，并在内联中注入
  const injectedStyles = `
    <style>
      /* 选项外层容器依旧纵向排列 */
      .rip-options-container {
        display: flex;
        flex-direction: column;
      }
      /* 选项行：去掉固定高度、允许换行、自动撑高 */
      .rip-option-row {
        display: flex !important;
        flex-wrap: wrap !important;
        height: auto !important;
        align-items: flex-start !important;
        padding: 6px 8px !important;
        gap: 8px !important;
        border-bottom: inherit !important;
      }
      /* 单选框保持原大小 */
      .rip-option-row input {
        // flex: 0 0 auto !important;
        margin: 0 !important;
      }
      /* 文本标签占满剩余空间，自动换行 */
      .rip-option-row .rip-option-label {
        // flex: 1 1 auto !important;
        white-space: normal !important;
        word-break: break-word !important;
        margin: 0 !important;
        display: flex !important;
        align-items: center !important;
      }
    </style>
  `;

  const optionFontFamily = getFontFamily(
    optionsDefaultFont,
    root?.data?.defultFont
  );

  return `
    ${injectedStyles}

    <div
      class="rip-field-group"
      style="
        text-align: left;
        padding-top: ${paddingTop}px;
        padding-bottom: ${paddingBottom}px;
        padding-right: ${paddingRight}px;
        padding-left: ${paddingLeft}px;
      "
    >
    
      <label
        for="${id}"
        class="rip-field-label"
               style="${finalLabelStyleStr}; display: ${
    hideLabel ? "none" : "flex"
  };"
"
      >
        ${
          required
            ? '<span style="color: #ff4d4f; margin-right: 4px;">*</span>'
            : ""
        }${label}
      </label>

      <div
        class="rip-options-container"
        style="
          border-width: ${formBorderWidth}px;
          border-style: ${formBorderStyle};
          border-color: ${toRGBA(formBorderColor)};
          border-radius: ${formBorderRadius}px;
        "
      >
        ${options
          .map((item, index) => {
            const isLast = options.length === index + 1;
            const borderBottom = isLast
              ? 0
              : [
                  formBorderWidth + "px",
                  formBorderStyle,
                  toRGBA(formBorderColor),
                ].join(" ");

            return `
            <div
              class="rip-option-row"
              style="
                border-bottom: ${borderBottom};
                justify-content: ${optionsHorizonAlignment};
              "
            >
              <input
                type="radio"
                name="${id}"
                id="${id}-${index}"
                value="${item.label}"
                style="
                  width: 16px;
                  height: 16px;
                  border-radius: 50%;
                  border: 1px solid #cccccc;
                "
              />
              <label
                for="${id}-${index}"
                class="rip-option-label"
                style="
                  color: ${toRGBA(optionsFontColor || formTextColor)};
                  font-family: ${optionFontFamily};
                  font-size: ${optionsFontSize}px;
                  justify-content: ${
                    optionsHorizonAlignment || "start"
                  }; /* 新增的样式 */
                "
              >
                ${item.label}
              </label>
            </div>`;
          })
          .join("")}
      </div>

      ${formFieldErrorHtml({ id })}
    </div>
  `;
};
